module.exports = __webpack_public_path__ + "static/media/ddof.39681005.jpg";